import Button from "@/components/Button";
import HighLightCard from "./components/HihglightCard";
import TableSection from "./components/TableSection";
import { useNavigate } from "react-router-dom";
import "./style.scss";
import { useEffect, useState } from "react";
import { ProductStats } from "@/@core/entity/product.entity";
import getProductStatsInteractor from "@/@core/interactor/product/get-product-stats";

const Products = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState<ProductStats>({
    total_claimed: 0,
    total_product: 0,
    total_unclaimed: 0,
    total_unlinked: 0
  })
  
  const getProductStats = async () => {
    try {
      const response = await getProductStatsInteractor()
      
      const {data: {data}} = response
      setStats(data)
    } catch(err) {
      console.error(err)
    }
  }

  useEffect(() => {
    getProductStats()
  }, [])

  return (
    <div className="products-page-wrapper">
      <div className="header-page">
        <h1>Products</h1>

        <div className="btn-wrapper">
          <Button
            label="Bulk Add"
            type="secondary"
            size="md"
            startIcon="setting"
          />
          <Button
            label="Product"
            size="md"
            startIcon="plus"
            onClick={() => navigate("add-product")}
          />
        </div>
      </div>

      <div className="content">
        <div className="highlight-info-wrapper">
          <HighLightCard
            title="Total product"
            value={String(stats.total_product)}
            percentage="15%"
            status="down"
          />
          <HighLightCard
            title="Product claimed"
            value={String(stats.total_claimed)}
            percentage="15%"
            status="up"
          />
          <HighLightCard
            title="Product unclaimed"
            value={String(stats.total_unclaimed)}
            percentage="15%"
            status="down"
          />
          <HighLightCard
            title="Product unlinked"
            value={String(stats.total_unlinked)}
            percentage="15%"
            status="down"
          />
        </div>

        <TableSection />
      </div>
    </div>
  );
};

export default Products;
